import React from "react";
import AnimatedText from "../Components/animation/text/AnimatedText";
import { motion } from "framer-motion";
import ImageShowdown from "../Components/animation/images/ImageShowdown";
import FireAnim from "../Components/animation/emojis/FireAnim";


const images = [
    { key: "1", path: "./Photos/cake.JPG" },
    { key: "2", path: "./Photos/barca.jpg" },
    { key: "3", path: "./Photos/domenica.jpg" },
    { key: "4", path: "./Photos/coruna.jpeg" },
    { key: "5", path: "./Photos/Moledo_sunset.jpg" },
    { key: "6", path: "./Photos/Douro.jpg" },

];

const About = () => {
    const ref = React.useRef();
    const [inView, setInView] = React.useState(false);

    React.useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setInView(true);
                } else {
                    setInView(false);
                }
            });
        });

        observer.observe(ref.current);

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div id="about" className="w-full flex flex-col items-center justify-center overflow-hidden mt-10">

            <div className="w-full xl:w-[70%] flex flex-row pb-16">
                <div className="w-full">
                    <AnimatedText text="About Me" />

                    <p className="text-secondary-400 text-[18px] mt-5 ml-12">
                        Hi there, I am <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700">Ricardo de Matos </span>
                        and this is my personal website.
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-1 ml-[5em]">
                        &gt; I recently graduated with a master's degree in Informatics and Computing Engineering from FEUP.  🔭
                    </p>
                    <p className="text-secondary-400 text-[18px] mt-1 ml-[5em]">
                        &gt; I have a great passion for photography, chess and technology. ♟️
                    </p>
                    <p className="text-secondary-400 text-[18px] mt-1 ml-[5em]">
                        &gt; ... But most importantly, I love to learn new things and to challenge myself. 🚀
                    </p>
                    <p className="text-secondary-400 text-[18px] mt-1 ml-[5em]">
                        &gt; Fun fact: When I was a child, I wanted to be a fireman, so I signed up to volunteer at a local fire department. 🚒
                    </p>

                </div>
                <motion.div
                    ref={ref}
                    className="w-full xl:w-[30%] flex justify-center items-center mt-[10em]"
                    initial={{ opacity: 0, scale: 0 }}
                    animate={{ opacity: inView ? 1 : 0, scale: inView ? 1 : 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <motion.img
                        drag
                        dragConstraints={ref}
                        src="/RicardoPic.jpg" alt="random"
                        className="ml-10 w-500 h-500 object-cover rounded-full border-2 border-gray-500" />
                </motion.div>
            </div>


            <ImageShowdown images={images} />

            <FireAnim />

        </div>
    );
}

export default About;
